module.exports = __webpack_public_path__ + "img/point-map.cfd22743.png";